import React, { useEffect, useState } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputController from 'components/Form/InputController';
import { FileImageValid, ModalType, ROOT_API } from 'constants/common';
import { toast } from 'components/Toast';

import { ErrorForm } from 'constants/error';
import * as yup from 'yup';
import SelectController from 'components/Form/SelectController';
import { BotTeleFormValidate } from 'utils/validation';
import { mappingOptionSelect } from 'utils/mapping';
import { useCreateBotTeleMutation, useUpdateBotTeleMutation } from 'services/bottelegram';
import isEmpty from 'lodash/isEmpty';
import { token } from 'stylis';

const CreateBotTeleModal = ({ isOpen, botTeleDetail, optionData ,onClose, refetch }) => {
  const cancelRef = React.useRef();
  const createBotTeleMutation = useCreateBotTeleMutation();
  const updateBotTeleMutation = useUpdateBotTeleMutation();
  const [brandingSelect,setBrandingSelect] = useState() 


  const { control, handleSubmit,reset } = useForm({
    resolver: yupResolver(BotTeleFormValidate),
    defaultValues: {
      token: "",
      groupId: "",
      brandingId: undefined,
    },
  });

  useEffect(() => {
      if (!isEmpty(optionData?.data)) {
        setBrandingSelect(mappingOptionSelect(optionData?.data, "name", "_id"));
      }
    }, []);

    useEffect(() => {
        if (botTeleDetail) {
        reset({ 
          token: botTeleDetail.token, 
          groupId: botTeleDetail.groupId,
          brandingId: brandingSelect?.find(item => item?.value === botTeleDetail?.brandingId?._id),
         });
      }
    }, [botTeleDetail,brandingSelect]);

  const handleSuccess = () => {
    toast.showMessageSuccess(`${botTeleDetail ? 'Cập nhật' : 'Tạo'} Bot Telegram thành công`);
    refetch?.();
    onClose(ModalType.Add);
  };

  const handleError = error => {
    toast.showMessageError(
      error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || `${botTeleDetail ? 'Cập nhật' : 'Tạo'} Bot Telegram thành công`
    );
  };

  const onSubmit = async values=> {
    if (botTeleDetail) {
      updateBotTeleMutation.mutate(
        { 
          token: values.token, 
          telegramId: botTeleDetail?._id,
          groupId: values.groupId,
          brandingId: values.brandingId.value,
        },
        {
          onSuccess: () => handleSuccess(),
          onError: error => handleError(error),
        }
      );
    } else {
      createBotTeleMutation.mutate(
        { 
          token: values.token, 
          groupId: values.groupId,
          brandingId: values.brandingId.value,
        },
        {
          onSuccess: () => handleSuccess() ,
          onError: error => handleError(error),
        }
      );
    }
  };

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose(ModalType.Add);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent maxW={'600px'}>
          <AlertDialogHeader textTransform="uppercase">{botTeleDetail ? 'Cập nhật' : 'Tạo'} Bot Telegram</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <form>
              <InputController control={control} name="token" label="Token" styleContainer={{ mt: 3 }} isRequired/>
              <InputController control={control} name="groupId" label="Group Id" styleContainer={{ mt: 3 }} isRequired />
              <SelectController control={control} name="brandingId" label={"Branding"} placeholder="Chọn Branding" options={brandingSelect} styleContainer={{ mt: 3 }} isRequired/>
            </form>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose(ModalType.Add);
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              isLoading={createBotTeleMutation.isPending || updateBotTeleMutation.isPending}
              onClick={handleSubmit(onSubmit)}
            >
              {botTeleDetail ? 'Cập nhật' : 'Tạo'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default CreateBotTeleModal;
